query companyStateValues($id: String!) {
  company(id: $id) {
    id
    state {
      stringValues
    }
  }
}
